<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>

        <v-flex xs12 md6>
          <v-text-field
            label="Client ID"
            v-model="resource.client_id"
            required
            :error-messages="validationErrors.client_id">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md6>
          <v-text-field
            label="Client Secret"
            v-model="resource.client_secret"
            required
            :error-messages="validationErrors.client_secret">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md6>
          <v-text-field
            label="Refresh Token"
            v-model="resource.refresh_token"
            required
            :error-messages="validationErrors.refresh_token">
          </v-text-field>
        </v-flex>

      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ZohoReportCredentialService from '@/features/zoho-report-credential/ZohoCredentialService';

export default {
  name: 'zoho-report-credential-form',
  mixins: [CrudMixin],
  methods: {
    initCrud() {
      this.serviceType = ZohoReportCredentialService;
      this.routerName = 'zoho-report-credential';
      this.componentType = 'FORM';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/zoho-report-credential/ZohoReportCredentialForm.vue